// components/TransitionLink.js
'use client'
import { usePathname, useRouter } from 'next/navigation'
import { createContext, useContext, useLayoutEffect, useRef, useState } from 'react'
import Link from 'next/link'
import gsap from 'gsap'

// Create context for managing transitions
const TransitionContext = createContext({})

export const PageWrapper = ({ children }) => {
  const { isTransitioning } = useContext(TransitionContext)
  const contentRef = useRef(null)
  const pathname = usePathname()

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Reset position
      gsap.set(contentRef.current, {
        x: '100%',
        opacity: 0
      })

      // Animate in
      gsap.to(contentRef.current, {
        x: '0%',
        opacity: 1,
        duration: 0.8,
        ease: 'power4.out'
      })
    })

    return () => ctx.revert()
  }, [pathname])

  return (
    <div 
      ref={contentRef} 
     
    >
      {children}
    </div>
  )
}

// TransitionLink component for smooth page transitions
export const TransitionLink = ({ href, children, className, ...props }) => {
  const router = useRouter()
  const pathname = usePathname()
  
  const handleClick = (e) => {
    e.preventDefault()
    if (href !== pathname) {
      router.push(href)
    }
  }

  return (
    <Link href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}

const TransitionProvider = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false)

  return (
    <TransitionContext.Provider value={{ isTransitioning, setIsTransitioning }}>
      <div className=" w-full h-full overflow-auto">
        {children}
      </div>
    </TransitionContext.Provider>
  )
}

export default TransitionProvider